import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  userProfileRequest: null,
  userProfileSuccess: ['data'],
  userProfileFailure: ['error'],
});

export const UserProfileTypes = Types;
export default Creators;

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  userRole: null,
  fullName: null,
  dealer: {
    name: null,
    city: {
      name: null,
    }
  },
  permissions: {},
  error: null,
  fetching: false
});

/* ------------- Reducers ------------- */

export const request = state => state.merge({fetching: true, error: null});

export const success = (state, { data }) =>
  state.merge({fetching: false, error: null, ...data});

export const failure = (state, { error }) =>
  state.merge({ fetching: false, error });

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.USER_PROFILE_REQUEST]: request,
  [Types.USER_PROFILE_SUCCESS]: success,
  [Types.USER_PROFILE_FAILURE]: failure,
});

/* ------------- Selectors ------------- */
